import { render, staticRenderFns } from "./listaPuentesScroll.vue?vue&type=template&id=4d5783c4&"
import script from "./listaPuentesScroll.vue?vue&type=script&lang=js&"
export * from "./listaPuentesScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports